import { type SingleSelectedValueFilter } from 'components/brokers/types'

const EmployerOEMinEmployeeCountFilter = ({
  selectedValue,
  selectValue,
}: SingleSelectedValueFilter) => {
  return (
    <input
      type='number'
      placeholder='Min employee count'
      value={selectedValue || ''}
      onChange={(e) => selectValue(e.target.value)}
      className='block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
      min={0}
    />
  )
}

export default EmployerOEMinEmployeeCountFilter
